module.exports = __webpack_public_path__ + "fonts/236c113.ttf";